export const SET_ACTIVE_DOWNLOAD_BTN = 'SET_ACTIVE_DOWNLOAD_BTN';